import component from './PhGameController.vue_vue&type=script&lang.js';
export { default } from './PhGameController.vue_vue&type=script&lang.js';
import { render } from './PhGameController.vue_vue&type=template&id=2ea4d738&lang.js';

component.render = render;
